import { InputItemType } from '../types';

/** Город по-умолчанию */
export const DEFAULT_CITY: InputItemType = {
  city: 'Москва',
  cityId: 1405113,
};
